import React, { useState, useEffect } from "react";
import { Box, Typography } from "@mui/material";
import h1 from "../../../res/Services/HotelBooking/h1.jpg";
import h2 from "../../../res/Services/HotelBooking/h2.jpg";
import h3 from "../../../res/Services/HotelBooking/h3.jpg";

const images = [h1, h2, h3];
const imageTexts = [
  "Experience Luxury Like Never Before",
  "Discover Extraordinary Comfort in Hotels",
  "Your Dream Vacation Starts Here",
];

// Preload images function
const preloadImages = (imageArray) => {
    imageArray.forEach((src) => {
        const img = new Image();
        img.src = src;
    });
};

const ImageScroller = () => {
    const [currentIndex, setCurrentIndex] = useState(0);
    const [loaded, setLoaded] = useState(false);

    useEffect(() => {
        preloadImages(images);
        setLoaded(true);

        const interval = setInterval(() => {
            setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
        }, 3000);

    return () => clearInterval(interval);
  }, []);

  if (!loaded) {
    return <Typography>Loading...</Typography>;
}

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
        height: "320px",
        overflow: "hidden",
        position: "relative",
      }}
    >
      {/* Image Container */}
      <Box
        sx={{
          position: "relative",
          width: "100%",
          height: "100%",
        }}
      >
        {images.map((src, index) => (
          <Box
            key={index}
            sx={{
              position: "absolute",
              width: "100%",
              height: "100%",
              opacity: index === currentIndex ? 1 : 0,
              transition: "opacity 0.8s ease-in-out",
            }}
          >
            <Box
              component="img"
              src={src}
              alt={`Hotel Image ${index + 1}`}
              sx={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
            {/* Text Overlay */}
            <Typography
              sx={{
                position: "absolute",
                left: "16px",
                bottom: "50px",
                color: "white",
                fontSize: "2rem",
                fontWeight: "bold",
                textShadow: "2px 2px 4px rgba(0, 0, 0, 0.5)",
              }}
            >
              {imageTexts[index]}
            </Typography>

            {/* Dots Overlay */}
            <Box
              sx={{
                position: "absolute",
                left: "50%",
                bottom: "16px",
                transform: "translateX(-50%)",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                gap: "8px",
              }}
            >
              {images.map((_, dotIndex) => (
                <Box
                  key={dotIndex}
                  sx={{
                    width: "10px",
                    height: "10px",
                    borderRadius: "50%",
                    backgroundColor: dotIndex === currentIndex ? "#027BFE" : "white",
                    transition: "background-color 0.3s ease",
                    cursor: "pointer",
                  }}
                  onClick={() => setCurrentIndex(dotIndex)}
                />
              ))}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ImageScroller;
